import type { ReactNode } from "react";

export type Tone = "neutral" | "run" | "warn" | "err" | "gold";

export function Pill({
  tone = "neutral",
  dot = false,
  children,
  className = "",
}: {
  tone?: Tone;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}) {
  const toneClass = tone === "neutral" ? "" : `pill-${tone}`;
  return (
    <span className={`pill ${toneClass} ${className}`}>
      {dot && <span aria-hidden className="size-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}

/** A dataset field name, in mono. */
export function FieldChip({ children }: { children: ReactNode }) {
  return <span className="field-chip">{children}</span>;
}
